import styled from 'styled-components';

import MotifBreadcrumb from '@ey/motif-react-wrapper/Breadcrumb';

export default styled(MotifBreadcrumb)`
	.motif-breadcrumb-list,
	.motif-breadcrumb-list-item {
		margin: 0;
	}
`;
